module.exports = __webpack_public_path__ + "static/media/constraq-icon.dce1570e.svg";